/**
 * The customer liability route table (FIN-FR-024, FSD Part 2 s-2.1 catalogue, follow-up #69).
 *
 * Exported as `LIABILITY_ROUTES`; INT imports and spreads it in `web/src/router/index.ts` and
 * adds the nav item (id `liability-instruments`, section s-2.1, code FIN-FR-024). One route: the
 * register, the breakage report and the breakage policy are tabs of one screen (`?tab=`), so the
 * nav item covers everything this module routes.
 *
 * The server declares every liability route under the general-ledger entitlement (`gl`); the
 * route meta has no entitlement key, so the server's refusal is the gate for an unentitled plan.
 */

import type { RouteRecordRaw } from 'vue-router'

import { LIABILITY_PERMISSIONS } from '@/modules/liability/permissions'

export const LIABILITY_NAV = {
  id: 'liability-instruments',
  section: 's-2.1',
  code: 'FIN-FR-024',
  labelKey: 'liability.nav.label',
  descriptionKey: 'liability.nav.description',
  to: '/finance/liability-instruments',
  permission: LIABILITY_PERMISSIONS.read,
} as const

/** The tabs of the screen, in order. `settings` is offered only with `finance.liability.manage`. */
export const LIABILITY_TABS = ['register', 'breakage', 'settings'] as const
export type LiabilityTab = (typeof LIABILITY_TABS)[number]

export const LIABILITY_ROUTES: RouteRecordRaw[] = [
  {
    path: '/finance/liability-instruments',
    name: 'liability-instruments',
    component: () => import('@/modules/liability/LiabilityInstrumentsView.vue'),
    meta: { titleKey: 'liability.routeTitles.instruments', permission: LIABILITY_PERMISSIONS.read },
  },
]
